var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTheeeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 24,
    viewBox: "0 0 7 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.07362 21.2308C6.07362 21.9652 5.78186 22.6696 5.26253 23.1889C4.7432 23.7082 4.03883 24 3.30439 24C2.56994 24 1.86558 23.7082 1.34624 23.1889C0.826913 22.6696 0.535156 21.9652 0.535156 21.2308C0.535156 20.4963 0.826913 19.792 1.34624 19.2726C1.86558 18.7533 2.56994 18.4615 3.30439 18.4615C4.03883 18.4615 4.7432 18.7533 5.26253 19.2726C5.78186 19.792 6.07362 20.4963 6.07362 21.2308ZM6.07362 12C6.07362 12.7344 5.78186 13.4388 5.26253 13.9581C4.7432 14.4775 4.03883 14.7692 3.30439 14.7692C2.56994 14.7692 1.86558 14.4775 1.34624 13.9581C0.826913 13.4388 0.535156 12.7344 0.535156 12C0.535156 11.2656 0.826913 10.5612 1.34624 10.0419C1.86558 9.52253 2.56994 9.23077 3.30439 9.23077C4.03883 9.23077 4.7432 9.52253 5.26253 10.0419C5.78186 10.5612 6.07362 11.2656 6.07362 12ZM6.07362 2.76923C6.07362 3.50368 5.78186 4.20804 5.26253 4.72737C4.7432 5.2467 4.03883 5.53846 3.30439 5.53846C2.56994 5.53846 1.86558 5.2467 1.34624 4.72737C0.826913 4.20804 0.535156 3.50368 0.535156 2.76923C0.535156 2.03479 0.826913 1.33042 1.34624 0.811089C1.86558 0.291757 2.56994 0 3.30439 0C4.03883 0 4.7432 0.291757 5.26253 0.811089C5.78186 1.33042 6.07362 2.03479 6.07362 2.76923Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTheeeDots);
export default __webpack_public_path__ + "static/media/whiteTheeeDots.cd1d30ed7b501a968f7e898b7742e229.svg";
export { ForwardRef as ReactComponent };